/* tslint:disable */
/* eslint-disable */
/**
 * chinaone-java
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { UserPointsHistoryRespVo } from './UserPointsHistoryRespVo';
import {
    UserPointsHistoryRespVoFromJSON,
    UserPointsHistoryRespVoFromJSONTyped,
    UserPointsHistoryRespVoToJSON,
    UserPointsHistoryRespVoToJSONTyped,
} from './UserPointsHistoryRespVo';

/**
 * 
 * @export
 * @interface PageDataUserPointsHistoryRespVo
 */
export interface PageDataUserPointsHistoryRespVo {
    /**
     * 当前页
     * @type {number}
     * @memberof PageDataUserPointsHistoryRespVo
     */
    currentPage?: number;
    /**
     * 总页数
     * @type {number}
     * @memberof PageDataUserPointsHistoryRespVo
     */
    totalPage?: number;
    /**
     * 总记录数
     * @type {number}
     * @memberof PageDataUserPointsHistoryRespVo
     */
    totalRecord?: number;
    /**
     * 列表内容
     * @type {Array<UserPointsHistoryRespVo>}
     * @memberof PageDataUserPointsHistoryRespVo
     */
    records?: Array<UserPointsHistoryRespVo>;
}

/**
 * Check if a given object implements the PageDataUserPointsHistoryRespVo interface.
 */
export function instanceOfPageDataUserPointsHistoryRespVo(value: object): value is PageDataUserPointsHistoryRespVo {
    return true;
}

export function PageDataUserPointsHistoryRespVoFromJSON(json: any): PageDataUserPointsHistoryRespVo {
    return PageDataUserPointsHistoryRespVoFromJSONTyped(json, false);
}

export function PageDataUserPointsHistoryRespVoFromJSONTyped(json: any, ignoreDiscriminator: boolean): PageDataUserPointsHistoryRespVo {
    if (json == null) {
        return json;
    }
    return {
        
        'currentPage': json['currentPage'] == null ? undefined : json['currentPage'],
        'totalPage': json['totalPage'] == null ? undefined : json['totalPage'],
        'totalRecord': json['totalRecord'] == null ? undefined : json['totalRecord'],
        'records': json['records'] == null ? undefined : ((json['records'] as Array<any>).map(UserPointsHistoryRespVoFromJSON)),
    };
}

export function PageDataUserPointsHistoryRespVoToJSON(json: any): PageDataUserPointsHistoryRespVo {
    return PageDataUserPointsHistoryRespVoToJSONTyped(json, false);
}

export function PageDataUserPointsHistoryRespVoToJSONTyped(value?: PageDataUserPointsHistoryRespVo | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'currentPage': value['currentPage'],
        'totalPage': value['totalPage'],
        'totalRecord': value['totalRecord'],
        'records': value['records'] == null ? undefined : ((value['records'] as Array<any>).map(UserPointsHistoryRespVoToJSON)),
    };
}

